import { create } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';

const isWeb = false;

const storage = isWeb
  ? createJSONStorage(() => localStorage)
  : createJSONStorage(() => AsyncStorage);

interface SearchStore {
  symbols?: string[];
  setSymbol: (symbol: string) => void;
  clearSymbols: () => void;
}

export const useSearchStore = create<SearchStore>()(
  devtools(
    persist(
      (set) => ({
        symbols: undefined,
        clearSymbols: () => {
          set({ symbols: [] });
        },
        setSymbol: (symbol) => {
          set((state) => {
            if (state.symbols) {
              const newSymbols = [
                symbol,
                ...state.symbols
                  .slice()
                  .filter((s) => symbol !== s)
                  .slice(0, 4),
              ];
              return { symbols: newSymbols };
            } else {
              return { symbols: [symbol] };
            }
          });
        },
      }),
      {
        name: 'search-store',
        partialize: (state) => {
          return { symbols: state.symbols };
        },
        storage: storage,
        // onRehydrateStorage: (a) => {
        //   console.log('rehydrating user store');

        //   return (b) => {
        //     b?.setIsLoadingToken(false);
        //   };
        // },
      }
    )
  )
);
